/**
 * Helper function to transform enum values to API format (lowercase with spaces)
 */
export const toApiFormat = (value: string): string => {
  return value
    .split('_')
    .map((word) => word.toLowerCase())
    .join(' ');
};

/**
 * Helper function to get display text for complaint status
 */
export const getComplaintStatusDisplay = (status: string): string => {
  return status
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Helper function to get display text for complaint filed by
 */
export const getComplaintFiledByDisplay = (filedBy: string): string => {
  return filedBy
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Helper function to get display text for reason subcategory
 */
export const getReasonSubcategoryDisplay = (subcategory: string): string => {
  return subcategory
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
